import React, { Fragment } from 'react'
import { DatePicker } from 'components/shared/datePicker'
import BpostSelect, {BpostInput, BpostSelectCreatable} from '../bpostSelect'
import {reduxForm} from "redux-form"
import styles from './contacts.scss'
import cs from 'classnames'
import nesProp from 'nested-property'

import i18n from 'lib/i18n'
import SelectWrapper from '../shared/select/SelectWrap'
const _ = i18n('officeContactPopup')

const requiredFields = ["firstName", "lastName", "birthday", "email", "street", "houseNum", "zipCity"]
let belgiumWordsForValidate = []

const validate = values => {
	const errors = {}

	if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
		errors.email = 'invalid'
	}
	if (!/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/i.test(values.birthday)) {
		errors.birthday = 'invalid'
	}
	for (const item of requiredFields) {
		if (!values[item]) {
			errors[item] = 'required'
		}
    }

    // this will be an id
    let isBelgium = values.country && values.country == 1 || false
    let isEmptySelectedZipCity = Boolean(values["zipCitySelected"])
    let isEmptyZipTyped = !String(nesProp.get(values, "zipTyped")).trim()
    let isEmptyCityTyped = !String(nesProp.get(values, "cityTyped")).trim()

    if (isBelgium && !isEmptySelectedZipCity) {
        errors['zipCitySelected'] = 'required'
    } else {
        if(isEmptyCityTyped){
            errors['cityTyped'] = 'required'
        }

        /* if(isEmptyZipTyped){
            errors['zipTyped'] = 'required'
        } */
    }

    return errors
}

@reduxForm({
    form: "contact",
    fields: ["firstName", "lastName", "birthday", "email", "street", "houseNum", "houseNumExt", "zipCity",
    "zipCitySelected", "zipTyped", "cityTyped", "mobile", "phone", "country", "language"],
    validate,
    destroyOnUnmount: true,
    touchOnBlur: true,
})
export default class ContactModal extends React.Component {
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        handleSubmit: React.PropTypes.func.isRequired,
        onCloseModal: React.PropTypes.func.isRequired,
        onSaveContact: React.PropTypes.func.isRequired,
        countries: React.PropTypes.array,
        zipCodeOptions: React.PropTypes.array,
    }

    /**
     * This function update field values in redux form.
     * @param {*} value
     * @param {*} field
     */
    updateFormValue(value, field) {
        const {dispatch} = this.props

        dispatch({
            type: "redux-form/CHANGE",
            field: field.name,
            value: value && value.value || '',
            touch: value && value.touched || field.touched,
            form: "contact"
        })

        this.forceUpdate()
    }

    /**
     * This function fired when the component receive a new property
     * @param {object} nextProps - the next state of properties
     */
    componentWillReceiveProps(nextProps) {
        // change values for zip city input and selector, assign select, replace if possible
        this.handleZipCityUpdateProps(nextProps)
    }

    /**
     * This function handle the property changes process for zip city inputs values
     * @param {string} nextProps - the props of nex state of the module
     */
    handleZipCityUpdateProps(nextProps) {
        const {fields: {zipCitySelected, country, zipCity, zipTyped, cityTyped}, zipCodeOptions, countries} = this.props

        // synchronization the selected zip city to the free input, that one will sent forward
        let selectedCountryId = nesProp.get(nextProps, "fields.country.value") || ''
        let isBelgium = selectedCountryId && selectedCountryId == 1 || false
        let wasSomethingChanged = false

        // get new selected value
        let zipCitySelectedValue = nesProp.get(nextProps, "fields.zipCitySelected.value") || ''
        let zipCitySelectedValueDigested = zipCitySelectedValue.replace("_", ", ")
        let oldZipCitySelectedValue = nesProp.get(this.props, "fields.zipCitySelected.value") || ''

        // prepare values
        let zipTypedValue = nesProp.get(nextProps, "fields.zipTyped.value") || ''
        let cityTypedValue = nesProp.get(nextProps, "fields.cityTyped.value") || ''
        let oldZipTypedValue = nesProp.get(this.props, "fields.zipTyped.value") || ''
        let oldCityTypedValue = nesProp.get(this.props, "fields.cityTyped.value") || ''
        let typedZipCityCombo = zipTypedValue + ", " + cityTypedValue
        let oldTypedZipCityCombo = oldZipTypedValue + ((oldCityTypedValue && oldZipTypedValue) ? ", " : "") + oldCityTypedValue

        let finalZipCity = isBelgium ? zipCitySelectedValueDigested : oldTypedZipCityCombo

        // --- if belgium selected ---
        if (isBelgium) {
            // is required update
            if (oldZipCitySelectedValue != zipCitySelectedValue) {
                this.updateFormValue(
                    {
                        ...nextProps.fields.zipCitySelected,
                        value: zipCitySelectedValue
                    },
                    zipCitySelected
                )

                // this will be the final value to set for zipCity field
                finalZipCity = zipCitySelectedValueDigested
                wasSomethingChanged = true
            }

        } else {
        // --- if not belgium selected ---

            // if zip changed by typing
            if (oldZipTypedValue != zipTypedValue) {
                this.updateFormValue(
                    {
                        ...nextProps.fields.zipTyped,
                        value: zipTypedValue
                    },
                    zipTyped
                )

                // this will be the final value to set for zipCity field
                finalZipCity = typedZipCityCombo
                wasSomethingChanged = true
            }

            // if city changed by typing
            if (oldCityTypedValue != cityTypedValue) {
                this.updateFormValue(
                    {
                        ...nextProps.fields.cityTyped,
                        value: cityTypedValue
                    },
                    cityTyped
                )

                // this will be the final value to set for zipCity field
                finalZipCity = typedZipCityCombo
                wasSomethingChanged = true
            }
        }

        // check if zipCity must be updated changed
        let oldZipCityValue = nesProp.get(zipCity, "value") || ''

        // finally set the zipCity value for the form
        if (oldZipCityValue != finalZipCity) {
            this.updateFormValue(
                {
                    ...nextProps.fields.zipCity,
                    value: finalZipCity
                },
                zipCity
            )
            // console.log("finalZipCity CAHNGED to ", finalZipCity)
        } else {
            // console.log("finalZipCity NOT changed from", oldZipCityValue, "to", finalZipCity)
        }
    }

    touch(field) {
        field.onBlur()
    }

	render() {
		const {fields: {firstName, lastName, birthday, email, street, houseNum,
			houseNumExt, zipCity, zipCitySelected, zipTyped, cityTyped, mobile, phone, country, language}, handleSubmit,
			onCloseModal, onSaveContact, countries} = this.props

        let selectedCountryId = nesProp.get(country, "value") || ''
        let isBelgium = selectedCountryId && selectedCountryId == 1 || false

        const onSubmit = handleSubmit((formData)=>{
            formData.country = (countries && nesProp.get(countries.filter((oneCountry)=>(oneCountry.value == formData.country)), "0.label")) || ""
            return onSaveContact(formData)
        })

        return (
			<div className={styles.contactForm}>
				<label>
					<span>{_('firstName')} *</span>
					<input className={styles.contactInput} {...firstName}/>
					<span className={styles.error}>
						{firstName.error && firstName.touched &&
							firstName.error === 'required' && <span>{_('required')}</span>
						}
					</span>
				</label>
				<label>
					<span>{_('lastName')} *</span>
					<input className={styles.contactInput} {...lastName}/>
					<span className={styles.error}>
						{lastName.error && lastName.touched &&
							lastName.error === 'required' && <span>{_('required')}</span>
						}
					</span>
				</label>
				<label>
					<span>{_('birthday')} *</span>
					<div className={styles.contactInput}>
						<DatePicker {...birthday}/>
					</div>
					<span className={styles.error}>
						{birthday.error && birthday.touched &&
							(birthday.error === 'required' ? <span>{_('required')}</span> : <span>{_('invalidDate')}</span>)
						}
					</span>
				</label>
				<label>
					<span>{_('email')} *</span>
					<input className={styles.contactInput} {...email}/>
					<span className={styles.error}>
						{email.error && email.touched &&
							(email.error === 'required' ? <span>{_('required')}</span> : <span>{_('invalidEmail')}</span>)
						}
					</span>
				</label>
                <div className={styles.addressWrapper}>
                    <label  className={styles.full}>
						<span>{_('country')} *</span>
                        <SelectWrapper
                            className={styles.contactInput}
                            {...country}
                            options={countries}
                        />
						<span className={styles.error}>
							{country.error && country.touched &&
								country.error === 'required' && <span>{_('required')}</span>
							}
						</span>
                    </label>

                    <div className={styles.inputRow}>
                        <span>
                            <label>
                                <span>{_('street')} *</span>
                                <input className={styles.contactInput} {...street}/>
                                <span className={styles.error}>
                                    {street.error && street.touched &&
                                        street.error === 'required' && <span>{_('required')}</span>
                                    }
                                </span>
                            </label>
                            <label className={styles.half}>
                                <span>{_('houseNum')} *</span>
                                <input className={styles.contactInput} {...houseNum}/>
                                <span className={styles.error}>
                                    {houseNum.error && houseNum.touched &&
                                        houseNum.error === 'required' && <span>{_('required')}</span>
                                    }
                                </span>
                            </label>
                            <label className={styles.half}>
                                <span>{_('houseNumExt')}</span>
                                <input className={styles.contactInput} {...houseNumExt}/>
                            </label>
                        </span>

                        {isBelgium ?
                            <label className={styles.full}>
                                <span>{_('city')} &nbsp; & &nbsp; {_('zip')} *</span>
                                <div className={styles.gemPostcode}>
                                    <BpostSelect
                                        {...zipCitySelected}
                                        optionsListCallback={(options)=>{
                                            this.setState({zipCitySelectedOptions: options})
                                        }}
                                    />
                                </div>
                                <span className={styles.error}>
                                    {zipCitySelected.touched && zipCitySelected.error &&
                                        zipCitySelected.error === 'required' && <span>{_('required')}</span>
                                    }
                                </span>
                            </label>
                        :
                            <span>
                                <label>
                                    <span>{_('zip')}</span>
                                        <BpostInput
                                            {...zipTyped}
                                            className={styles.contactInput}
                                            onChange={(value)=>{
                                                return zipTyped.onChange(value)
                                            }}
                                        />
                                    <span className={styles.error}>
                                        {zipTyped.touched && zipTyped.error &&
                                            zipTyped.error === 'required' && <span>{_('required')}</span>
                                        }
                                    </span>
                                </label>
                                <label>
                                    <span>{_('city')} *</span>
                                        <BpostInput
                                            {...cityTyped}
                                            className={styles.contactInput}
                                            onChange={(value)=>{
                                                return cityTyped.onChange(value)
                                            }}
                                        />
                                    <span className={styles.error}>
                                        {cityTyped.touched && cityTyped.error &&
                                            cityTyped.error === 'required' && <span>{_('required')}</span>
                                        }
                                    </span>
                                </label>
                            </span>
                        }
                    </div>
					<div className={styles.addressInfo}>
						{_('privateAddress')}
					</div>
                </div>

				<label>
					<span>{_('mobile')} </span>
					<input className={styles.contactInput} {...mobile}/>
				</label>
				<label>
					<span>{_('phone')} </span>
					<input className={styles.contactInput} {...phone}/>
				</label>
				<label>
					<span>{_('language')} </span>
					<select className={styles.contactInput} {...language}>
						<option></option>
						<option value="nl">NL</option>
						<option value="fr">FR</option>
						<option value="en">EN</option>
					</select>
				</label>
				<div className={styles.buttons}>
					<div onClick={() => onCloseModal()} className={styles.cancel}>{_('cancel')}</div>
					<div onClick={() => onSubmit()} className={styles.next + " " + styles.enabled}>{_('confirm')}</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/contactModal.jsx